import axiosInstance from "./axios";
import {
  CreateOrganizationPayload,
  Organization,
  UpdateOrganizationPayload,
} from "./models/organization.models";

const apiUrl = import.meta.env.VITE_BACKEND_API_URL;

export const createOrganization = async (
  bearerToken: string,
  payload: CreateOrganizationPayload
): Promise<Organization> => {
  try {
    const response = await axiosInstance.post(
      `${apiUrl}/Companies/${payload.companyId}/organizations`,
      {
        ...payload,
      },
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to create organization:", error);
    throw error;
  }
};

export const updateOrganization = async (
  bearerToken: string,
  payload: UpdateOrganizationPayload
): Promise<Organization> => {
  try {
    const response = await axiosInstance.put(
      `${apiUrl}/Companies/${payload.companyId}/organizations`,
      {
        ...payload,
      },
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to update organization:", error);
    throw error;
  }
};

export const deleteCompanyOrganization = async (
  bearerToken: string,
  companyId: number,
  organizationId: number
): Promise<void> => {
  try {
    await axiosInstance.delete(
      `${apiUrl}/Companies/${companyId}/organizations/${organizationId}`,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
  } catch (error) {
    console.error("Failed to delete organization:", error);
    throw error;
  }
};

export const fetchOrganizationReports = async (
  bearerToken: string,
  companyId: number,
  organizationId: number
): Promise<Report[]> => {
  try {
    const response = await axiosInstance.get(
      `${apiUrl}/Report/reports/${companyId}?organizationId=${organizationId}`,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch organization reports:", error);
    throw error;
  }
};
